module.exports = __webpack_public_path__ + "img/lakewood.4c125e25.png";